"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetTemplatesResolver = exports.GetTemplates = exports.GetTemplatesResponse = exports.GetTemplateByIdResolver = exports.GetTemplateById = void 0;
const effect_1 = require("effect");
const types_1 = require("../types");
const errors_1 = require("./errors");
exports.GetTemplateById = effect_1.Request.tagged('@fixtuur/Gavel/GetTemplateById');
const GetTemplateResponse = effect_1.Schema.Struct({
    templates: effect_1.Schema.Array(types_1.TemplateWithId),
});
const GetTemplateByIdResolver = (http) => effect_1.RequestResolver.fromEffect((request) => effect_1.Effect.gen(function* () {
    const result = yield* http
        .get(`${request.baseUrl}/api/v1/${request.tenant}/templates/${request.id}`)
        .pipe(effect_1.Effect.flatMap(response => response.json), effect_1.Effect.flatMap(effect_1.Schema.decodeUnknown(GetTemplateResponse)), effect_1.Effect.mapError(originalError => new errors_1.TemplateReadError({ originalError })));
    if (result.templates[0] === undefined || result.templates[0][1] === undefined) {
        return yield* effect_1.Effect.fail(new errors_1.TemplateReadError({ originalError: new Error('Unable to find result') }));
    }
    return result.templates[0];
}).pipe(effect_1.Effect.scoped));
exports.GetTemplateByIdResolver = GetTemplateByIdResolver;
exports.GetTemplatesResponse = effect_1.Schema.Struct({
    templates: effect_1.Schema.Array(types_1.TemplateWithId),
    cursor: effect_1.Schema.optional(effect_1.Schema.String),
});
class GetTemplates extends effect_1.Request.TaggedClass('@fixtuur/Gavel/GetTemplates') {
}
exports.GetTemplates = GetTemplates;
const GetTemplatesResolver = (http) => effect_1.RequestResolver.fromEffect(({ baseUrl, tenantId, noSpace, pagination, spaceId }) => effect_1.Effect.gen(function* () {
    const urlParams = effect_1.Record.filter(effect_1.Record.fromEntries([
        ['noSpace', noSpace],
        ['cursor', pagination === null || pagination === void 0 ? void 0 : pagination.cursor],
        ['count', pagination === null || pagination === void 0 ? void 0 : pagination.limit],
        ['space', spaceId],
    ]), effect_1.Predicate.isNotUndefined);
    return yield* http
        .get(`${baseUrl}/api/v1/${tenantId}/templates`, {
        acceptJson: true,
        urlParams,
    })
        .pipe(effect_1.Effect.flatMap(result => result.json), effect_1.Effect.flatMap(effect_1.Schema.decodeUnknown(exports.GetTemplatesResponse)), effect_1.Effect.mapError(originalError => new errors_1.TemplateReadError({ originalError })));
}).pipe(effect_1.Effect.scoped));
exports.GetTemplatesResolver = GetTemplatesResolver;
